import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getDataCustomer(params) {
    return client.get("api/customer/data", {
        params: params,
    });
}

function getDetailCustomer(params) {
    return client.get("api/customer/detail", {
        params: {
            network_code: params
        },
    });
}

function getDetailCustomerByMid(params) {
    return client.get("api/customer/detail-by-mid", {
        params: {
            network_mid: params
        },
    });
}

function addCustomer(params) {
    return client.post("api/customer/create", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function updateCustomer(params) {
    return client.post("api/customer/edit", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function updatePasswordCustomer(params) {
    return client.post("api/customer/edit-password", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function rejectCustomer(params) {
    return client.post("api/customer/reject", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function checkgs(params) {
    return client.get("api/customer/check_gs", {
        params: params,
    });
}

function getCustomerArea(params) {
    return client.get("api/customer/area-stockist", {
        params: params,
    });
}

function loginSsoPOS(params) {
    return client.post("api/customer/sso-pos", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function searchCustomer(params) {
    return client.get("api/customer/search", {
        params: {
            search_value: params
        },
    });
}

function searchMemberMLM(params) {
    return client.get("api/customer/search_member_mlm", {
        params: {
            search_value: params
        },
    });
}

function exportCustomer(params) {
    return client.get("api/customer/export", {
        params: params,
    });
}

function updateStatus(params) {
    return client.post("api/customer/status", qs.stringify(params), {
        header: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    });
}

function getDataPromo77() {
  return client.get("api/customer/promo77-report");
}

function getDataPromoSept2022() {
  return client.get("api/customer/promo-september2022-report");
}

export default {
    getDataCustomer,
    getDetailCustomer,
    getDetailCustomerByMid,
    addCustomer,
    updateCustomer,
    updatePasswordCustomer,
    rejectCustomer,
    checkgs,
    getCustomerArea,
    loginSsoPOS,
    searchCustomer,
    searchMemberMLM,
    exportCustomer,
    updateStatus,
    getDataPromo77,
    getDataPromoSept2022,
}
